var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLastBgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 896,
    height: 1209,
    viewBox: "0 0 896 1209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.659 710.073C304.297 818.826 192.831 899.56 95.3814 942.186C46.6556 963.5 1.4571 975.276 -37.3336 976.279C-76.1214 977.282 -108.466 967.515 -131.552 945.784C-154.639 924.054 -166.344 892.36 -167.689 853.582C-169.034 814.802 -160.013 768.974 -141.685 719.048C-105.031 619.199 -31.185 503.055 71.1773 394.303C173.54 285.551 285.005 204.816 382.455 162.19C431.181 140.877 476.379 129.101 515.17 128.098C553.958 127.095 586.302 136.862 609.389 158.592C632.475 180.322 644.181 212.017 645.525 250.794C646.87 289.575 637.849 335.403 619.521 385.328C582.867 485.177 509.021 601.321 406.659 710.073Z",
    stroke: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M549.729 498.001C645.211 612.841 711.775 733.307 742.22 835.221C757.443 886.179 763.629 932.475 759.902 971.099C756.176 1009.72 742.543 1040.64 718.164 1060.9C693.785 1081.17 660.901 1088.93 622.249 1085.55C583.593 1082.16 539.204 1067.63 491.881 1043.36C397.237 994.821 290.947 907.385 195.465 792.545C99.9839 677.704 33.42 557.239 2.97458 455.325C-12.2484 404.367 -18.4343 358.071 -14.7075 319.446C-10.981 280.825 2.65111 249.911 27.0304 229.641C51.4097 209.371 84.2933 201.612 122.946 204.998C161.602 208.384 205.991 222.917 253.313 247.187C347.958 295.724 454.248 383.16 549.729 498.001Z",
    stroke: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLastBgLeft);
export default __webpack_public_path__ + "static/media/ic-last-bg-left.1bd7f0a1a0f03c472746023ec92986e1.svg";
export { ForwardRef as ReactComponent };